<template>
  <v-app class="primary">
    <v-content>
      <v-container fill-height fluid>
        <router-view></router-view>
      </v-container>
    </v-content>
    <v-footer color="transparent" class="pr-3" dark app>
      <v-spacer></v-spacer>
      <div>v{{ version }}</div>
    </v-footer>
    <ac-snackbar></ac-snackbar>
  </v-app>
</template>

<script>
import AcSnackbar from '@produtos/vue-acacia-plugin/src/components/plugin/snackbar/AcSnackbar';
import AcToolbarAcaciaAction from '@produtos/vue-acacia-plugin/src/components/plugin/toolbar/AcToolbarAcaciaAction';

export default {
  name: 'App',
  components: {
    AcSnackbar,
    AcToolbarAcaciaAction,
  },
  computed: {
    version() {
      return process.env.VERSION;
    },
  },
};
</script>

<style scoped>
  .application {
    background-size: cover;
    background-position: 50%;
    background-repeat: no-repeat;
    background-image: url('assets/material_background.svg');
  }
</style>

<style>
  html, body {
    min-width: 320px;
  }

  .float-label .v-label {
    transform: translateY(-18px) scale(0.75) !important;
  }

  .float-label input::selection {
    background-color: #1976d2; /* cor de fundo da seleção */
    color: white; /* cor do texto selecionado */
  }

  /* Caso use textarea */
  .float-label textarea::selection {
    background-color: #1976d2;
    color: white;
  }

  /* Remove a cor de fundo do autofill no Chrome */
  .float-label input:-webkit-autofill {
    box-shadow: 0 0 0px 1000px white inset !important; /* cor de fundo */
    -webkit-text-fill-color: #000 !important;          /* cor do texto */
    transition: background-color 5000s ease-in-out 0s; /* truque pra evitar o flash */
  }

  /* Se estiver usando tema dark */
  .theme--dark .float-label input:-webkit-autofill {
    box-shadow: 0 0 0px 1000px #121212 inset !important;
    -webkit-text-fill-color: #fff !important;
  }

  /* Remove o fundo do autofill */
  .float-label input:-webkit-autofill {
    box-shadow: 0 0 0 1000px white inset !important;
    -webkit-text-fill-color: #000 !important;
    transition: background-color 5000s ease-in-out 0s;
  }

  /* Força o label a flutuar quando o Chrome aplica autofill */
  .float-label input:-webkit-autofill ~ .v-label {
    transform: translateY(-18px) scale(0.75) !important;
    color: #1976d2 !important; /* opcional: mesma cor do foco */
  }
</style>



// WEBPACK FOOTER //
// src/App.vue